<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-basket</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <PrinterForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import PrinterForm from '../../components/printer/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Printer';

export default {
  name: 'PrinterUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin],
  components: {
    Loading,
    Toolbar,
    PrinterForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields('printer', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('printer', ['find'])

  },

  methods: {
    ...mapActions('printer', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),

  }
};
</script>
